import React, { useState, useEffect } from 'react';
import './About.css';
import { FaMap, FaSearchLocation, FaKey, FaBrain, FaDatabase, FaUserLock, FaGlobeAmericas } from 'react-icons/fa';
import AuthDialog from './AuthDialog';

const About = ({ isAuthenticated, onSearch }) => {
    const [featureCards, setFeatureCards] = useState([
        {
            id: "counties",
            icon: <FaGlobeAmericas size="100%" className="feature-icon" />,
            title: "Navix",
            description: "Explore flood models by county with interactive map visualization.",
            isAvailable: true,
            requiresAuth: false
        },
        {
            id: "map",
            icon: <FaMap size="100%" className="feature-icon" />,
            title: "Map Search",
            description: "Interactive map interface with drawing tools for spatial queries.",
            isAvailable: true,
            requiresAuth: true
        },
        {
            id: "location",
            icon: <FaSearchLocation size="100%" className="feature-icon" />,
            title: "Location Search",
            description: "Explore by city or county name.",
            isAvailable: true,
            requiresAuth: true
        },
        {
            id: "keyword",
            icon: <FaKey size="100%" className="feature-icon" />,
            title: "Keyword Search",
            description: "Advanced search based on keywords such as project name, HUC, event and model type.",
            isAvailable: true,
            requiresAuth: true
        },
        {
            id: "ai",
            icon: <FaBrain size="100%" className="feature-icon" />,
            title: <>AI-Based Search <span className="experimental-badge">Beta</span></>,
            description: "Natural language querying for flood model discovery",
            isAvailable: true,
            requiresAuth: true
        },
        {
            id: "datasets",
            icon: <FaDatabase size="100%" className="feature-icon" />,
            title: "Datasets",
            description: "Explore additional datasets and documents that have been uploaded to TDIS.",
            isAvailable: true,
            requiresAuth: true
        }
    ]);

    const [isVisible, setIsVisible] = useState(false);
    const [showAuthDialog, setShowAuthDialog] = useState(false);

    useEffect(() => {
        setIsVisible(true);
    }, []);

    const shouldUseAutoWidth = featureCards.length <= 3;

    const handleFeatureClick = (card) => {
        if (card.requiresAuth && !isAuthenticated) {
            setShowAuthDialog(true);
            return;
        }
        onSearch(card.id);
    };

    return (
        <div className="about-container">
            {/* Hero Image Section */}
            <div className={`about-hero-image ${isVisible ? 'fade-in' : ''}`}>
                <img
                    src="/assets/Flooded-Overlay.jpg"
                    alt="Texas Coastal Flooding"
                    className="about-hero-img"
                />
                <div className="hero-banner-text">
                </div>
                <div className="about-hero-overlay">
                    <div className="overlay-content">
                        <p className="tdis-description">
                        The Texas Disaster Information System (TDIS) is a comprehensive data platform designed to support natural disaster management in Texas. Through collaborative efforts, TDIS aims to deliver critical research on disaster risk reduction, support state agencies with data analytics and decision-making tools, and generate evidence-based solutions that help Texas communities become more resilient over the long term.
                        </p>
                    </div>
                </div>
            </div>

            {/* Content Container */}
            <div className={`about-content-full ${isVisible ? 'fade-in-up' : ''}`}>
                <div className="about-content">
                    <p className="about-description">
                    DMQT provides emergency management agencies and communities the ability to search, discover, and reuse models stored on the TDIS platform.
                    </p>

                    <div className="features-container">
                        <div
                            className={`features-grid ${shouldUseAutoWidth ? 'auto-width' : ''}`}
                        >
                            {featureCards.map((card, index) => (
                                <div
                                    key={index}
                                    className={`feature-card ${card.requiresAuth && !isAuthenticated ? 'feature-locked' : ''}`}
                                    onClick={() => handleFeatureClick(card)}
                                >
                                    {card.requiresAuth && !isAuthenticated && (
                                        <div className="lock-indicator">
                                            <FaUserLock />
                                        </div>
                                    )}
                                    {card.icon}
                                    <h5>{card.title}</h5>
                                    <p>{card.description}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
            <AuthDialog 
                isOpen={showAuthDialog} 
                onClose={() => setShowAuthDialog(false)} 
            />
        </div>
    );
};

export default About;